import AudioCubeApiCallerInstance from "../utils/AudioCubeApiCallerInstance";
import { SOUNDBOX_API_ENDPOINTS } from "../URLConstants";

export const GetAllMerchants = (pageNo, limit, where, sortBy, sortByField) => {

        const response = AudioCubeApiCallerInstance.get(`${SOUNDBOX_API_ENDPOINTS.GET_MERCHANT_LIST}?page=${pageNo}&limit=${limit}`, {
                params: {
                        "where": JSON.stringify(where),
                        "order": JSON.stringify({ ...(sortByField && { [sortByField]: sortBy }) })
                }
        })
        return response;

}

export const GetMerchantById = async (deviceId) => {
        const response = await AudioCubeApiCallerInstance.get(`${SOUNDBOX_API_ENDPOINTS.GET_DEVICE_BY_ID}/${deviceId}`)
        return response;
}

export const AddNewMerchant = async (name, phone, merchantUpiId, organizationId, ifsc, deviceRequest, qrString,
        language, deviceVariant, rentToBeCollected, waiverCode, merchantId, secretyKey, city, state, address, pincode, image) => {

        const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.ADD_NEW_MERCHANT, {
                "name": name,
                "phone": phone,
                "key": merchantId,
                "secret_key": secretyKey,
                "address": address,
                "state": state,
                "city": city,
                "pincode": pincode,
                "image": image,
                "activated": false,
                "merchant_upi_id": merchantUpiId,
                "organizationId": organizationId,
                "ifsc": ifsc,
                "device_request": deviceRequest,
                "qr_string": qrString,
                "language": language,
                "variant": deviceVariant,
                "rent_to_be_collected": rentToBeCollected,
                "waiver_code": waiverCode
        })
        return response;

}

export const MerchantBulkUpload = async (file, organizationId) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("organizationId", organizationId)
        const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.MERCHANT_BULK_UPLOAD, formData, {
                headers: {
                        "Content-Type": "multipart/form-data",
                },
        })

        return response

}

export const GetMerchantTransactions = async (organizationId, merchantId, fileterType, serachBy, pageNo, limit) => {
        const response = await AudioCubeApiCallerInstance.post(`${SOUNDBOX_API_ENDPOINTS.GET_DEVICE_TRANSACTION}?page=${pageNo}&limit=${limit}`, {
                "organizationId": organizationId,
                "merchant_id": merchantId,
                "filter_type": fileterType,
                "search_by": serachBy
        })
        return response;
}

export const ExportMerchantReport = async (organizationId, fromDate, toDate) => {
        const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.EXPORT_MERCHANT_REPORT, {
                "organizationId": organizationId,
                "from_date": fromDate,
                "to_date": toDate,

        })
        return response;
}

export const ExportMerchantReportWithFilter = async (payload) => {
        const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.EXPORT_MERCHANT_REPORT, payload)
        return response;
}




export const ExportTransactionReport = async (organizationId, fromDate, toDate) => {
        const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.EXPORT_TRANSACTION_REPORT, {
                "organizationId": organizationId,
                "from_date": fromDate,
                "to_date": toDate,

        })
        return response;
}

export const GetMerchantOnlineStatus = async (deviceId) => {
        const response = await AudioCubeApiCallerInstance.get(`${SOUNDBOX_API_ENDPOINTS.GET_MERCHANT_ONLINE_STATUS}${deviceId}`)
        return response;
}



